import MainLayout from "../layouts/MainLayout";
import {useEffect, useState} from "react";
import OtcTabContainer from "../components/otc/OtcTabContainer";
import {Wrapper, OtcMainContent} from "../styles/MainOtcStyle"
import OtcMarketComp from "../components/otc/OtcMarketComp";


const Otc = () => {

    const [activeTab, setActiveTab] = useState("market")

    const onTabButtonClicked = (type) => {
        setActiveTab(type)
    }

    useEffect(() => {
        document.title = "Otc"
    }, [])

    return(
        <MainLayout>
            <Wrapper>
                <OtcTabContainer
                    activeTab={activeTab}
                    onTabButtonClicked={(type) => onTabButtonClicked(type)}
                />

                <OtcMainContent>
                    <OtcMarketComp activeTab={activeTab} />
                </OtcMainContent>

                {/*<OtcFaqComp />*/}
            </Wrapper>
        </MainLayout>
    )
}

export default Otc;